import { PropertyEvaluator, type Evaluator } from './base/evaluator'
import { ItemObject } from './base/item_object'
import { ItemType } from './base/types'
import { type TextMessage } from './i18n'

export class Text extends ItemObject {
  /** longer description additonally to the title */
  help?: TextMessage

  visibleEvaluator?: Evaluator<boolean>
  visible: boolean = true

  constructor (id: string, title: TextMessage, type?: ItemType) {
    super(id, type ?? ItemType.Group, title)
  }

  public read (o: any): this {
    super.read(o)
    if (Object.prototype.hasOwnProperty.call(o, 'visible') && (o.visible !== undefined)) {
      if (typeof o.visible === 'boolean') {
        this.visible = o.visible
      } else {
        if (this.visibleEvaluator === undefined) {
          this.visibleEvaluator = new PropertyEvaluator<boolean>('true', this, 'visible')
        }
        this.visibleEvaluator = this.visibleEvaluator.read(o.visible)
      }
    }
    return this
  }

  public save (): any {
    const result = super.save()
    if (this.visibleEvaluator) {
      result.visible = this.visibleEvaluator.save()
    } else {
      if (!this.visible) {
        result.visible = this.visible
      }
    }
    return result
  }
}
